import {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {searchWorkspace, suggestSearch, SEARCHABLE_COLLECTIONS} from '../services/search.js';
import {workspacePath} from '../services/paths.js';

const {FiSearch, FiArrowRight, FiX, FiBookmark, FiFileText, FiCheckSquare, FiFolder, FiMessageSquare} = FiIcons;

const ICONS = {
  businessMemory: FiBookmark,
  plans: FiFileText,
  tasks: FiCheckSquare,
  files: FiFolder,
  chatMessages: FiMessageSquare
};

export default function HqSearchCard({state}) {
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState('all');
  const [results, setResults] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      setSuggestions([]);
      return;
    }

    const timer = setTimeout(() => {
      const hits = searchWorkspace(query, {
        collection: filter === 'all' ? null : filter,
        limit: 5
      });
      setResults(hits);
      setSuggestions(suggestSearch(query, 3));
    }, 120);

    return () => clearTimeout(timer);
  }, [query, filter]);

  function handleSelect(result) {
    const dest = workspacePath(result.moduleRoute, state);
    navigate(dest);
  }

  return (
    <div className="hq-search-card panel">
      <div className="section-heading">
        <div>
          <span className="eyebrow">Universal recall</span>
          <h3>Search business memory &amp; work</h3>
        </div>
        <small className="muted">Typo-tolerant · Client-local</small>
      </div>

      <div className="hq-search-input-wrap">
        <SafeIcon icon={FiSearch} className="search-icon" />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Type to search memory, plans, tasks, files, messages…"
          className="hq-search-input"
        />
        {query && (
          <button type="button" className="clear-btn" onClick={() => setQuery('')}>
            <SafeIcon icon={FiX} />
          </button>
        )}
      </div>

      {suggestions.length > 0 && query && (
        <div className="hq-search-suggestions">
          <small>Did you mean:</small>
          {suggestions.map((sug) => (
            <button key={sug} type="button" onClick={() => setQuery(sug)} className="chip compact">
              {sug}
            </button>
          ))}
        </div>
      )}

      {results.length > 0 && (
        <div className="hq-search-results">
          {results.map((hit) => {
            const Icon = ICONS[hit.collection] || FiFileText;
            return (
              <div key={hit.id} className="hq-search-hit" onClick={() => handleSelect(hit)}>
                <SafeIcon icon={Icon} className="hit-icon" />
                <div className="hit-info">
                  <div className="hit-header">
                    <b>{hit.title}</b>
                    <span className="hit-badge">{hit.collection}</span>
                  </div>
                  <p>{hit.text}</p>
                </div>
                <SafeIcon icon={FiArrowRight} className="hit-arrow" />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
